csui.require.config({
  bundles: {
'aie/bundles/aie-all': [
'aie/aviator.commands/thumbs.feedback/impl/feedback.view',
'aie/behaviors/chart/chart.behavior',
'aie/chatlets/node.list/node.list.view',
'aie/chatlets/taz/taz.view',
'aie/commands/aviator/impl/parameter.collectors-all',
'aie/commands/impl/enable.disable.ai',
'aie/controllers/chat/chat.controller',
'aie/controllers/viewer/viewer.controller',
'aie/controllers/extra.combined/extra.combined.controller',
'aie/controllers/extra.dialog/extra.dialog.controller',
'aie/controllers/extra.sidebar/extra.sidebar.controller',
'aie/controllers/extra.inlinepanel/extra.inlinepanel.controller',
'aie/controllers/extra.popover/extra.popover.controller',
'aie/controllers/global.aviator/global.aviator.controller',
'aie/controls/chat/chat.view',
'aie/controls/chat/impl/imexport/imexport',
'aie/controls/chat/impl/history.extra/history.extra.view',
'aie/controls/chat/impl/prompt.templates/webreport.loader',
'aie/controls/chat/impl/restrict.embeddings/restrict.embeddings.dialog',
'aie/controls/chat.inlinepanel/chat.inlinepanel.view',
'aie/controls/chat.panel/chat.panel.view',
'aie/controls/wrapper/wrapper.view',
'aie/controls/wrapper/chat.resizer',
'aie/lib/mockfetch',
'aie/models/all.children/fetch.all.children',
'aie/models/charts/charts',
'aie/models/charts/impl/aie.charts',
'aie/models/chat/chat.models',
'aie/models/features/impl/features.dialog',
'aie/models/many.actions/many.actions',
'aie/models/many.nodes/many.nodes',
'aie/models/quick.questions/impl/aie.quick.questions',
'aie/contexts/factories/current.chat.history.entry',
'aie/utils/clipboard/clipboard',
'aie/utils/network/network',
'aie/utils/semver/semver',
'aie/utils/text2html/text2html',
'aie/utils/viewer.utils/viewer.utils',
'aie/nls/lang',
'aie/widgets/aviator/aviator.view',
'json!aie/widgets/aviator/aviator.manifest.json',
'aie/widgets/launcher/launcher.view',
'json!aie/widgets/launcher/launcher.manifest.json',
'aie/widgets/navigator/navigator.view',
'json!aie/widgets/navigator/navigator.manifest.json'
],
'aie/bundles/aie-ext': [
'aie/commands/aviator/aviator',
'aie/commands/aviator/impl/parameter.collectors-ext',
'aie/commands/disable.ai/disable.ai',
'aie/commands/enable.ai/enable.ai',
'aie/commands/guide/guide',
'aie/aviator.commands/aviator.commands',
'aie/aviator.commands/open.help/open.help',
'aie/aviator.commands/chat.history/chat.history',
'aie/aviator.commands/extra.history/extra.history',
'aie/aviator.commands/clear.messages/clear.messages',
'aie/aviator.commands/clear.scope/clear.scope',
'aie/aviator.commands/clone.chat/clone.chat',
'aie/aviator.commands/configure.features/configure.features',
'aie/aviator.commands/open.chat.from.history/open.chat.from.history',
'aie/aviator.commands/delete.chat.from.history/delete.chat.from.history',
'aie/aviator.commands/rename.chat.in.history/rename.chat.in.history',
'aie/aviator.commands/copy.answer/copy.answer',
'aie/aviator.commands/copy.chat/copy.chat',
'aie/aviator.commands/default.reference/default.reference',
'aie/aviator.commands/delete.answer/delete.answer',
'aie/aviator.commands/export.chat/export.chat',
'aie/aviator.commands/export.prompt.templates/export.prompt.templates',
'aie/aviator.commands/import.chat/import.chat',
'aie/aviator.commands/import.prompt.templates/import.prompt.templates',
'aie/aviator.commands/navigate.to.reference/navigate.to.reference',
'aie/aviator.commands/open.reference/open.reference',
'aie/aviator.commands/play.reference/play.reference',
'aie/aviator.commands/prompt.designer/prompt.designer',
'aie/aviator.commands/read.answer/read.answer',
'aie/aviator.commands/restrict.embeddings/restrict.embeddings',
'aie/aviator.commands/copy.question/copy.question',
'aie/aviator.commands/redo.question/redo.question',
'aie/aviator.commands/retry.answer/retry.answer',
'aie/aviator.commands/switch.back/switch.back',
'aie/aviator.commands/switch.to.current.node/switch.to.current.node',
'aie/aviator.commands/switch.to.reference/switch.to.reference',
'aie/aviator.commands/thumbs.feedback/thumbs.feedback',
'aie/aviator.commands/view.reference/view.reference',
'aie/contexts/patch.toolbars/patch.toolbars',
'aie/controls/chat/impl/audio/speaker',
'aie/controls/chat/impl/prompt.designer/prompt.designer.loader',
'aie/controls/chat/impl/prompt.templates/prompt.templates.loader',
'aie/controls/global.button/global.aviator.behavior',
'aie/controls/global.button/global.button.view',
'aie/controls/global.button/global.button.v2.view',
'aie/icons/action.icons',
'aie/icons/icons_aie_action',
'aie/icons/icons_header',
'aie/icons/aie.jato.action.icons',
'aie/models/features/features',
'aie/nls/ext',
'aie/toolbars/aviator.toolitems',
'aie/toolbars/metadata.toolitems',
'aie/toolbars/navigation.header.controls',
'aie/toolbars/navigation.header.controls.v2',
'aie/toolbars/nodestable.header.toolitems',
'aie/toolbars/nodestable.toolitems',
'aie/toolbars/profile.toolitems',
'aie/toolbars/relatedworkspaces.toolitems',
'aie/toolbars/search.results.toolitems',
'aie/toolbars/tables.toolitems',
'aie/toolbars/tiles.toolitems',
'aie/toolbars/workspace.header.toolitems',
'aie/utils/ecm.links/ecm.link.evaluator',
'aie/utils/modules/modules',
'aie/utils/node.info/node.info',
'aie/utils/node.info/impl/aie.node.info',
'aie/utils/toolitem.utils/toolitem.utils'
],
'aie/bundles/aie-chartjs': [
'aie/lib/chart',
'aie/charts/chartjs/chartjs.view'
],
'aie/bundles/aie-echarts': [
'aie/lib/echarts',
'aie/charts/echarts/echarts.view'
],
'aie/bundles/aie-mermaid': [
'aie/lib/mermaid',
'aie/charts/mermaid/mermaid.view'
],
'aie/bundles/aie-plotly': [
'aie/lib/plotly',
'aie/charts/plotly/plotly.view'
],
'aie/bundles/aie-vega': [
'aie/lib/vega/embed',
'aie/charts/vega/vega.view'
]
  }
});